import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import { Url } from '@wix/da-url';
import CloseThin from '../../../Icons/generated/components/CloseThin';
import Input from '../../../Input';
import Button from '../../../Button';
import { BiEventType } from '../../../biLogger';
import { compose } from 'redux';
import withLogBiEvent from '../../../biLogger/hocs/withLogBiEvent';
import searchPopupInputSkin from './SearchPopupInput.skin.scss';
import s from './SearchPopup.scss';
var USERNAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9]$/;
/**
 * Currently this does not encapsulate its show logic and that is
 * left up to the parent header. I left it like that because I was
 * not sure about the hide/show rules between the desktop/mobile header
 * but did want to extract the view part at least into a partial.
 */
var SearchPopup = /** @class */ (function (_super) {
    __extends(SearchPopup, _super);
    function SearchPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showButton: false,
        };
        _this.searchFormRef = React.createRef();
        _this.refSearchInput = function (input) {
            _this.searchInputRef = input;
        };
        _this.handleSearchPopupInputKeyDown = function (event) {
            if (event.key === 'Enter' || event.key === 'Return') {
                event.preventDefault();
                event.stopPropagation();
                _this.handleSubmit(event);
            }
        };
        _this.handleChange = function (value) {
            _this.setState({ showButton: value !== '' });
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            if (!_this.state.showButton) {
                return; // dont allow empty search
            }
            var searchTerm = _this.searchInputRef.value;
            var logBiEvent = _this.props.logBiEvent;
            var searchUrl = Url.searchLink(searchTerm);
            var username = searchTerm.slice(1);
            var isCorrectUsername = searchTerm.startsWith('@') && USERNAME_REGEX.test(username);
            logBiEvent({
                evid: BiEventType.SEARCH_CLICK,
                search_terms: searchTerm,
                sectionname: 'popup',
            });
            // Only search usernames if we are not on subdomain!
            if (isCorrectUsername && !_this.props.isLegacyHeader) {
                var userLinkUrl_1 = Url.userLink(username);
                // to test this locally do `.replace('.com', '.lan')`
                var http = new XMLHttpRequest();
                http.open('HEAD', userLinkUrl_1);
                http.onreadystatechange = function () {
                    if (this.readyState === this.DONE) {
                        var doesUserExists = this.status === 200;
                        var redirectUrl = doesUserExists ? userLinkUrl_1 : searchUrl;
                        window.location.assign(redirectUrl);
                    }
                };
                http.send();
            }
            else {
                window.location.assign(searchUrl);
            }
        };
        return _this;
    }
    SearchPopup.prototype.componentDidMount = function () {
        this.focus();
    };
    SearchPopup.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, isMobile = _a.isMobile, t = _a.t;
        var query = queryString.parse(location.search);
        return (React.createElement(Modal, { overlayClassName: s['search-popup'], className: s['search-popup-content'], shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, onRequestClose: onClose, isOpen: true },
            React.createElement("div", null,
                React.createElement("div", { className: s['search-popup-form'], onClick: this.preventSearchFormClosing },
                    React.createElement("form", { className: s['search-form'], action: Url.searchLink(), onSubmit: this.handleSubmit },
                        React.createElement(Input, { name: "q", autoComplete: "off", className: s['search-popup-input-layout'], skin: searchPopupInputSkin, label: t('siteHeader.searchField.input.label'), refInput: this.refSearchInput, autoFocus: true, onKeyDown: this.handleSearchPopupInputKeyDown, onChange: this.handleChange, defaultValue: query.q || undefined }),
                        React.createElement(Button, { className: classnames(s['search-submit-button'], isMobile && s['hidden'], this.state &&
                                this.state.showButton &&
                                s['search-submit-button-visible']), view: 'b16-undisciplined-designers', onClick: this.handleSubmit }, t('siteHeader.search.button'))),
                    React.createElement("button", { className: s['search-popup-close-button'], onClick: onClose },
                        React.createElement(CloseThin, null))),
                isMobile && this.renderSuggestions())));
    };
    SearchPopup.prototype.renderSuggestions = function () {
        var t = this.props.t;
        var items = [
            'Photography',
            'Body Art',
            'Artisan Designers',
            'Fashion',
            'Literature',
        ];
        return (React.createElement("div", { className: s['search-suggestions'] },
            React.createElement("h3", null, t('siteHeader.search.suggestions')),
            items.map(function (i) { return (React.createElement("a", { key: i, href: Url.searchLink(i.toLowerCase()) }, i)); })));
    };
    SearchPopup.prototype.focus = function () {
        if (!this.searchInputRef) {
            return;
        }
        this.searchInputRef.focus();
    };
    SearchPopup.prototype.preventSearchFormClosing = function (e) {
        e.stopPropagation();
    };
    return SearchPopup;
}(React.Component));
export { SearchPopup };
var enhance = compose(withTranslation(), withLogBiEvent);
export default enhance(SearchPopup);
//# sourceMappingURL=SearchPopup.js.map